var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForwardRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.31338 2.06051C7.91186 1.6813 7.89378 1.04839 8.27299 0.646875C8.6522 0.245357 9.28511 0.227274 9.68663 0.606485L15.6866 6.27315C15.8866 6.46206 16 6.72504 16 7.00017C16 7.27529 15.8866 7.53827 15.6866 7.72718L9.68663 13.3938C9.28511 13.7731 8.6522 13.755 8.27299 13.3535C7.89378 12.9519 7.91186 12.319 8.31338 11.9398L12.4848 8.00016H1C0.447715 8.00016 0 7.55245 0 7.00016C0 6.44788 0.447715 6.00016 1 6.00016H12.4848L8.31338 2.06051Z",
    fill: "#55489E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForwardRight);
export default __webpack_public_path__ + "static/media/arrow-forward-right.515063aa.svg";
export { ForwardRef as ReactComponent };